import { useIntl } from '@capsicum/common';
import { CountrySelect, DateInput, TextInput } from '@capsicum/common-web';
import { type AmlRequirementProps, useAmlPersonalInformation } from '@capsicum/features/regulations/shared';
import { FormProvider } from 'react-hook-form';

import * as S from './AmlQuestionnaire.styled';

export const PersonalInformation = ({ requirement }: AmlRequirementProps) => {
	const { $t } = useIntl();

	const { personalInformationForm } = useAmlPersonalInformation(requirement.config.prefill);

	return (
		<S.Wrapper>
			<FormProvider {...personalInformationForm}>
				<S.Question>{$t('amlQuestionnaire.personalInformationStep.question')}</S.Question>
				<TextInput
					autoCapitalize="none"
					disabled={!requirement.config.allowChangeOfNameAndDob}
					label={$t('global.firstName')}
					name="firstName"
					testID="aml-questionnaire-first-name-input"
				/>
				<TextInput
					autoCapitalize="none"
					disabled={!requirement.config.allowChangeOfNameAndDob}
					label={$t('global.lastName')}
					name="lastName"
					testID="aml-questionnaire-last-name-input"
				/>
				<DateInput
					disabled={!requirement.config.allowChangeOfNameAndDob}
					label={$t('global.dateOfBirth')}
					name="birthDate"
					testID="aml-questionnaire-date-of-birth-select"
				/>
				<CountrySelect
					label={$t('global.birthCountry')}
					labelProp="name"
					name="birthCountry"
					searchPlaceholder={$t('requirements.common.form.country.searchPlaceholder')}
					testID="aml-questionnaire-birth-country-select"
					withoutInitialValue
					withSearch
				/>
				<TextInput
					autoCapitalize="none"
					label={$t('global.birthCity')}
					name="birthCity"
					testID="aml-questionnaire-birth-city-input"
				/>
			</FormProvider>
		</S.Wrapper>
	);
};
